export enum GlobalSearchCustomEvent {
    HIDE_HEADER_ENTRY = 'gs:hideHeaderEntry',
    HIDE_FLOATING_ENTRY = 'gs:hideFloatingEntry',
    SHOW_HEADER_ENTRY = 'gs:showHeaderEntry',
    SHOW_FLOATING_ENTRY = 'gs:showFloatingEntry',
}
